<template>
  <div>
    <div class="d-flex align-center mx-2">
      <p>{{ text }}</p>
      <v-menu v-model="showMenu" absolute offset-y max-width="290px">
        <template v-slot:activator="{}">
          <div class="d-flex flex-column align-center ml-5">
            <div class="d-flex" style="position: relative">
              <div :class="`circle-back-${showMealStatus(item)}`"></div>
              <div :class="`circle-front-${showMealStatus(item)}`"></div>
            </div>
            <p class="body-2 grey--text">{{ showMealStatusText(item) }}</p>
          </div>
        </template>
        <v-list>
          <v-list-item v-for="(s, index) in statusList" :key="index">
            <v-list-item-title>
              <div class="d-flex align-center">
                <div class="d-flex flex-column align-center">
                  <div class="d-flex" style="position: relative">
                    <div :class="`circle-back-${s.status}`"></div>
                    <div :class="`circle-front-${s.status}`"></div>
                  </div>
                </div>
                <div class="ml-3">{{ s.title }}</div>
              </div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { defineComponent } from 'vue';
import {
  MealResponse,
  NurseryChildResponse,
  MealStatus,
  MealStatusType,
} from '../../../node_modules/chaild-entity/lib';

import { when } from '@/service/Switch';

export default defineComponent({
  props: {
    text: {
      type: String,
      required: true,
    },
    item: {
      type: String,
    },
  },
  data: () => {
    return {
      // btnLoading: false,

      showMenu: false,
      statusList: [
        { status: MealStatus.refill, title: 'おかわり' },
        { status: MealStatus.finished, title: '完食' },
        { status: MealStatus.unfinished, title: '少し残した' },
        { status: MealStatus.half, title: '半分食べた' },
        { status: MealStatus.little, title: '少し食べた' },
        { status: MealStatus.notEat, title: '食べなかった' },
        { status: MealStatus.notServed, title: '未提供' },
      ],
    };
  },
  computed: {},
  methods: {
    changeStatusItem(status: MealStatusType) {
      this.$emit('changeStatusItem', status, this.text);
    },
    showMealStatusText(status: MealStatusType): string {
      const temp = when(status)
        .on(
          (v) => v === MealStatus.refill,
          () => 'おかわり',
        )
        .on(
          (v) => v === MealStatus.finished,
          () => '完食',
        )
        .on(
          (v) => v === MealStatus.unfinished,
          () => '少し残した',
        )
        .on(
          (v) => v === MealStatus.half,
          () => '半分食べた',
        )
        .on(
          (v) => v === MealStatus.little,
          () => '少し食べた',
        )
        .on(
          (v) => v === MealStatus.notEat,
          () => '食べなかった',
        )
        .on(
          (v) => v === MealStatus.notServed,
          () => '未提供',
        )
        .otherwise(() => '');
      return temp;
    },
    showMealStatus(status: MealStatusType): string {
      const temp = when(status)
        .on(
          (v) => v === MealStatus.refill,
          () => 'refill',
        )
        .on(
          (v) => v === MealStatus.finished,
          () => 'finished',
        )
        .on(
          (v) => v === MealStatus.unfinished,
          () => 'unfinished',
        )
        .on(
          (v) => v === MealStatus.half,
          () => 'half',
        )
        .on(
          (v) => v === MealStatus.little,
          () => 'little',
        )
        .on(
          (v) => v === MealStatus.notEat,
          () => 'notEat',
        )
        .on(
          (v) => v === MealStatus.notServed,
          () => 'notServed',
        )
        .otherwise(() => '');
      return temp;
    },
  },
  async mounted() {},
});
</script>
<style lang="scss" scoped>
.circle-back-notEat,
.circle-back-little,
.circle-back-half,
.circle-back-unfinished,
.circle-back-finished,
.circle-back-refill {
  height: 34px;
  width: 34px;
  border-radius: 100%;
  background-color: rgb(var(--v-theme-primary));;
}
.circle-back-notServed {
  height: 34px;
  width: 34px;
  background-color: white;
}
.circle-front-notEat {
  height: 30px;
  width: 30px;
  top: 2px;
  left: 2px;
  border-radius: 100%;
  background-color: white;
  position: absolute;
}

.circle-front-little {
  height: 22px;
  width: 30px;
  top: 2px;
  left: 2px;
  border-radius: 22px 22px 5px 5px;
  background-color: white;
  position: absolute;
}
.circle-front-half {
  height: 15px;
  width: 30px;
  top: 2px;
  left: 2px;
  border-radius: 15px 15px 0px 0px;
  background-color: white;
  position: absolute;
}

.circle-front-unfinished {
  height: 15px;
  width: 30px;
  top: 2px;
  left: 2px;
  border-radius: 15px 15px 0px 0px;
  background-color: white;
  position: absolute;
  // border-top: 3px solid #ff6c00;
  // border-right: 1px solid #ff6c00;
  border-bottom: 7px solid rgb(var(--v-theme-primary));;
  // border-left: 1px solid #ff6c00;
}

.circle-front-finished {
  height: 30px;
  width: 30px;
  top: 1px;
  left: 1px;
  border-radius: 100%;
  background-color: rgb(var(--v-theme-primary));;
  position: absolute;
}

.circle-front-refill {
  height: 34px;
  width: 34px;
  left: 7px;
  border-radius: 100%;
  background-color: rgb(var(--v-theme-primary));;
  border: 1px solid white;
  position: absolute;
}

.circle-front-notServed {
  height: 5px;
  width: 34px;
  top: 17px;
  background-color: #c4c4c4;
  position: absolute;
}
</style>
